/**
 * Authentiation encapsulates all the functions required for successful authentication
 * of the user
 */

import { CognitoState } from "react-cognito";
import { setupCognito, cognito } from "react-cognito";
import config from "./config.json";
import { CognitoUserPool } from "amazon-cognito-identity-js";
const deniedRoutes = [
  {
    type: "",
    routes: [

    ]
  }
];

//import { Signin } from '../components/functional/authentication';

/**
 * SigninState is a proxy for cognitostate
 */

export const SigninState = CognitoState;
export const securityStore = cognito;

/**
 * getSigninStatus returns the current status of the user signin
 */
export const getSignInStatus = () => {
  return SigninState;
};

export const isRouteDenied = (type, route) => {
  //code needs to be enhanced for other types

  let routes = [];

  for (let i = 0; i < deniedRoutes.length; i++) {
    if (type === deniedRoutes[i].type) {
      routes = deniedRoutes[i].routes;
      break;
    }
  }
  if (route === undefined) {
    route = "";
  }
  let found = false;
  for (let i = 0; i < routes.length; i++) {
    if (route.toUpperCase() === routes[i].toUpperCase()) {
      found = true;
      break;
    }
  }
  return found;
};
export const extractRoute = route => {
  return route.substring(route.lastIndexOf("/") + 1);
};

export const initialize = store => {
  setupCognito(
    store,
    {
      region: config.region,
      userPool: config.userPool,
      identityPool: config.identityPool,
      clientId: config.clientId
    }
    // {
    //   "region": "ap-south-1",
    //   "userPool": "ap-south-1_Dec7mnBLU",
    //   "identityPool": "ap-south-1:0c45f5b6-b6a8-4b3d-ac6d-42dafbfd004b",
    //  "clientId": "4ltsr74aohda4nh4rbgekciteh"
    // }
  );
};

export const isUserLoggedIn = () => {
  var data = { UserPoolId: config.userPool, ClientId: config.clientId };
  var userPool = new CognitoUserPool(data);
  var cognitoUser = userPool.getCurrentUser();
  return cognitoUser != null && cognitoUser !== undefined;
};
